export const ga4: Record<string, string> = {
  'ga4.tab.byApp': 'Theo app',
  'ga4.tab.shared': 'Event chung',
  'ga4.pickApp': 'Chọn app…',
  'ga4.selectAppHint': 'Chọn app để xem số lần bắn event.',
  'ga4.clickEventHint': 'Bấm 1 event để xem xu hướng theo ngày.',
  'ga4.event': 'Event',
  'ga4.count': 'Số lần',
  'ga4.app': 'App',
  'ga4.total': 'Tổng (mọi app)',
  'ga4.dailyTrend': 'xu hướng theo ngày',
  'ga4.eventNamePlaceholder': 'tên event (vd purchase_pack_success)',
  'ga4.lookup': 'Tra',
  'ga4.sharedHint': 'Nhập tên event để cộng dồn qua tất cả app.',
  'ga4.paramNote': 'Lưu ý: breakdown param chỉ áp dụng với param đã đăng ký custom dimension/metric trên property đó (forward-only, chờ 24-48h mới có data). Param chưa đăng ký cần BigQuery export.',
  'ga4.noParamsRegistered': 'Property chưa đăng ký custom dimension/metric — chỉ xem được số lần bắn event.',
  'ga4.eventsShown': 'event hiển thị',
  'ga4.showAll': 'Hiện tất cả',
  'ga4.hideNoise': 'Ẩn nhiễu',
  'ga4.pin': 'Ghim (luôn hiện, cả team)',
  'ga4.unpin': 'Bỏ ghim',
  'ga4.hide': 'Ẩn (cả team)',
  'ga4.unhide': 'Bỏ ẩn',
  'ga4.paramNoData': 'Chưa có data — dimension chỉ gom từ lúc đăng ký, chờ 24-48h.',
}
